import CancelIcon from "@mui/icons-material/Cancel";
import GradientIcon from "@mui/icons-material/Gradient";
import React, { useState } from "react";
import { Box, IconButton, Typography, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const ImageCard = ({
  src,
  onDelete,
  DeleteDisplay = true,
  type,
  index,
  badgeContent = 1,
  handleCountChange,
  plusMarge = false,
  Rm_bg = false,
  changeBackground,
  srcRm = false,
  urlBg = false,
  displayCount = true,
  border = true,
  changeIconPlace = false,
}) => {
  const imgSrc = srcRm || src;
  const aspectRatio =
    type === "polaroid" ? "1 / 1" : type === "instax" ? "3 / 4" : "1 / 1";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Card
        style={{
          position: "relative",
          borderRadius: "20px",
          textAlign: "center",
          display: "inline-block",
          padding: border ? "8px" : "0px",
        }}
      >
        {/* Background change button */}
        {Rm_bg && (
          <IconButton
            onClick={() => changeBackground(index)}
            style={{
              zIndex: 2,
              position: "absolute",
              top: "6%" ,
              left: !changeIconPlace ? "10%" : "auto", // ← correct
              right: !changeIconPlace ? "auto" : "10px", // ← correct
              transform: "translateY(-50%)",
              color: "#1976d2",
              backgroundColor: "white",
              borderRadius: "50%",
              padding: "2px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            }}
          >
            <GradientIcon style={{ color: "black" }} />
          </IconButton>
        )}
        {displayCount && (
          <Box
            sx={{
              position: "absolute",
              bottom: "2%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}
          >
            <Counter
              initialValue={badgeContent}
              onChange={(newCount) => handleCountChange(index, newCount)}
            />
          </Box>
        )}

        <Box
          sx={{
            width: "100%",
            aspectRatio: aspectRatio,
            mx: "auto",
            borderRadius: "12px",
            overflow: "hidden",
            position: "relative",
            backgroundImage: urlBg ? `url(${urlBg})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
        >
          <Box
            component="img"
            src={imgSrc}
            alt="Image"
            sx={{
              width: "100%",
              height: "100%",
              display: "block",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Box>
        {DeleteDisplay && (
          <IconButton
            onClick={onDelete}
            style={{
              zIndex: 2,
              position: "absolute",
              top: "2%",
              right: "10px",
              backgroundColor: "white",
              color: "#B31312",
              borderRadius: "50%",
              padding: "2px",
            }}
          >
            <CancelIcon />
          </IconButton>
        )}
      </Card>
    </Box>
  );
};

export default ImageCard;

function Counter({ initialValue = 1, onChange }) {
  const [count, setCount] = useState(initialValue);

  const handleIncrement = () => {
    const newValue = count + 1;
    setCount(newValue);
    if (onChange) onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = count > 0 ? count - 1 : 0;
    setCount(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: "50px",
        padding: "4px 10px",
        boxShadow: 1,
      }}
    >
      {/* Minus Button */}
      <IconButton
        onClick={handleDecrement}
        sx={{
          backgroundColor: "#f0f0f0",
          "&:hover": { backgroundColor: "#e0e0e0" },
          width: 30,
          height: 30,
        }}
      >
        <RemoveIcon sx={{ color: "black", fontSize: 18 }} />
      </IconButton>

      {/* Count */}
      <Typography
        variant="subtitle1"
        sx={{ mx: 1, minWidth: 20, textAlign: "center", fontWeight: "bold" }}
      >
        {count}
      </Typography>

      {/* Plus Button */}
      <IconButton
        onClick={handleIncrement}
        sx={{
          backgroundColor: "#fde7eb",
          "&:hover": { backgroundColor: "#f8cdd5" },
          width: 30,
          height: 30,
        }}
      >
        <AddIcon sx={{ color: "#c62828", fontSize: 18 }} />
      </IconButton>
    </Box>
  );
}
